import { MergeTagsDataSource } from "../merge-tags-data-source.type";
import { APPOINTMENT_PROVIDER_VALUES } from "./appointment-provider-values";
import { CLINIC_VALUES } from "./clinic-values.utils";
import { CURRENT_USER_VALUES } from "./current-user-values";
import { FORM_CONTEXT_VALUES } from "./form-context-values.utils";
import { LEAD_CONTACT_VALUES } from "./lead-contact-values.utils";
import { MISCELLANEOUS_VALUES } from "./miscellaneous-values.utils";
import {
  PATIENT_APPOINTMENTS_VALUES,
  PATIENT_CURRENT_APPOINTMENT_VALUES
} from "./patient-appointment-values.utils";
import { PATIENT_BALANCE_VALUES } from "./patient-balance-values.utils";
import { PATIENT_CURRENT_REPORT_VALUES } from "./patient-current-report-values";
import { PATIENT_HEATING_AIDS_VALUES } from "./patient-hearing-aids-values/patient-hearing-aids-values.utils";
import { PATIENT_INFO_VALUES } from "./patient-info-values.utils";
import { PATIENT_LAST_REPORT_VALUES_VALUES } from "./patient-last-report-values";
import { PATIENT_MEDICARE_INSURANCE_POLICY_VALUES } from "./patient-medicare-insurance-policy-values.utils";
import { PATIENT_PRIMARY_INSURANCE_POLICY_VALUES } from "./patient-primary-insurance-policy-values.utils";
import { PATIENT_SECONDARY_INSURANCE_POLICY_VALUES } from "./patient-secondary-insurance-policy-values.utils";
import { PATIENT_SELECTED_INVOICE_VALUES } from "./patient-selected-invoice-values";
import { PURCHASE_AGREEMENT_SERVICE_VALUES } from "./purchase-agreement-service-values.utils";
import { PURCHASE_AGREEMENT_TAG_VALUES } from "./purchase-agreement-tag-values.utils";
import { PURCHASE_AGREEMENT_TOTALS_VALUES } from "./purchase-agreement-totals-values.utils";

export type MergeTagExtraDataKeys =
  | "patientSignatureURL"
  | "trialPeriodDurationDays"
  | "restockingReturnFee"
  | "lossDamageDeductible"
  | "warrantyDuration"
  | "memo"
  | "purchaseAgreementDate"
  | "leadContact"
  // ENG-2491: a Digital Form's own clinic, which Clinic.* and Practice.* read before the top-bar clinic.
  | "formClinic"
  // Form-context tags (ENG-2277): see form-context-values.utils.ts for the shapes.
  | "request"
  | "lossDamage"
  | "order"
  | "loaner"
  | "exchange";

export type MergeTagExtraData = Partial<Record<MergeTagExtraDataKeys, any>>;
export type MergeTagOptions = Record<string, any>;

export type MergeTagsReplaceHandlerParams = {
  data: MergeTagsDataSource;
  allowHtml: boolean;
  id: string | undefined;
  extraData?: MergeTagExtraData;
  options?: MergeTagOptions;
};

export type MergeTagsReplaceHandler = Record<
  string,
  (params: MergeTagsReplaceHandlerParams) => string | null | undefined
>;

const handlers = Object.entries({
  ...PATIENT_INFO_VALUES,
  ...CLINIC_VALUES,
  ...MISCELLANEOUS_VALUES,
  ...PATIENT_APPOINTMENTS_VALUES,
  ...PATIENT_CURRENT_APPOINTMENT_VALUES,
  ...PATIENT_BALANCE_VALUES,
  ...PATIENT_HEATING_AIDS_VALUES,
  ...PATIENT_SELECTED_INVOICE_VALUES,
  ...PURCHASE_AGREEMENT_TAG_VALUES,
  ...PURCHASE_AGREEMENT_TOTALS_VALUES,
  ...PURCHASE_AGREEMENT_SERVICE_VALUES,
  ...PATIENT_LAST_REPORT_VALUES_VALUES,
  ...PATIENT_CURRENT_REPORT_VALUES,
  ...PATIENT_PRIMARY_INSURANCE_POLICY_VALUES,
  ...PATIENT_SECONDARY_INSURANCE_POLICY_VALUES,
  ...PATIENT_MEDICARE_INSURANCE_POLICY_VALUES,
  ...CURRENT_USER_VALUES,
  ...APPOINTMENT_PROVIDER_VALUES,
  ...LEAD_CONTACT_VALUES,
  ...FORM_CONTEXT_VALUES
}).map(([mergeTagName, handlersMap]) => [`{{${mergeTagName}}}`, handlersMap]);

export const MERGE_TAGS_VALUE_HANDLERS: MergeTagsReplaceHandler =
  Object.fromEntries(handlers);
